import React from 'react';
import { Shield, Building2, User } from 'lucide-react';

/**
 * 프로필 사진 + 역할 아이콘 통합 아바타 컴포넌트
 *
 * @param {string} name - 사용자 이름 (이니셜 표시용)
 * @param {string} profileImage - 프로필 이미지 URL
 * @param {string} userType - 'member' | 'client'
 * @param {string} adminYn - 'Y' | 'N'
 * @param {number} size - 아바타 크기 (기본: 28)
 * @param {boolean} showRole - 역할 아이콘 표시 여부 (기본: true)
 * @param {string} className - 추가 클래스
 */
function UserAvatar({ name, profileImage, userType, adminYn, size = 28, showRole = true, className = '' }) {
  const isAdmin = adminYn === 'Y';
  const isClient = userType === 'client';

  const roleIconSize = size <= 20 ? 7 : size <= 28 ? 8 : size <= 64 ? 10 : 12;
  const badgeSize = size <= 20 ? 10 : size <= 28 ? 12 : size <= 64 ? 14 : 16;
  const badgeOffset = size <= 20 ? -4 : size <= 28 ? -3 : size <= 64 ? -2 : -1;

  return (
    <div className={`relative shrink-0 ${className}`} style={{ width: size, height: size }}>
      {profileImage ? (
        <img
          src={profileImage}
          alt={name}
          className="w-full h-full rounded-full object-cover"
          style={{ width: size, height: size }}
        />
      ) : (
        <div
          className={`w-full h-full rounded-full flex items-center justify-center font-bold text-white ${
            isAdmin ? 'bg-amber-600' : isClient ? 'bg-sky-600' : 'bg-emerald-600'
          }`}
          style={{ width: size, height: size, fontSize: size * 0.38 }}>
          {name?.charAt(0) || '?'}
        </div>
      )}
      {showRole && (
        <div
          className={`absolute flex items-center justify-center rounded-full border border-[#0d1526] ${
            isAdmin
              ? 'bg-amber-500'
              : isClient
              ? 'bg-rose-500'
              : 'bg-emerald-500'
          }`}
          style={{
            width: badgeSize,
            height: badgeSize,
            bottom: badgeOffset,
            right: badgeOffset,
          }}
          title={isAdmin ? '관리자' : isClient ? '권리사' : '일반회원'}>
          {isAdmin ? (
            <Shield size={roleIconSize} className="text-white" />
          ) : isClient ? (
            <Building2 size={roleIconSize} className="text-white" />
          ) : (
            <User size={roleIconSize} className="text-white" />
          )}
        </div>
      )}
    </div>
  );
}

export default UserAvatar;
